import React from 'react';

import PropTypes from 'prop-types';
import clsx from 'clsx';

import { CloseOutlinedCompIcon } from 'assets/icons';
import styles from './styles.module.scss';

const ModalHeader = ({
  title,
  subtitle,
  children,
  showCloseBtn,
  className,
  handleCloseBtnClick = () => {},
}) => {
  const renderCloseButton = showCloseBtn && (
    <button className={styles.close_btn} onClick={handleCloseBtnClick}>
      <CloseOutlinedCompIcon className={styles.close_btn__icon} />
    </button>
  );

  return (
    <div
      className={clsx([
        'modal__container__header flex flex-ai-s flex-jc-sb flex-wrap',
        className,
      ])}
    >
      <div className='modal__container__header__title'>
        {title && <h4>{title}</h4>}
        {subtitle && (
          <span className='modal__container__header__title__website'>
            {subtitle}
          </span>
        )}
        {renderCloseButton}
      </div>

      {children}
    </div>
  );
};

ModalHeader.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  children: PropTypes.node,
};

export default ModalHeader;
